module.exports = __webpack_public_path__ + "static/media/trophy.1ab39103.svg";